import { axiosInstance } from "./Api";



const posService = {
 
  getItemwiseStockOnline: async (): Promise<any> => {
   
    const response = await axiosInstance.get<any>('/EcomHome/Onlineitemdetails?outletid=1');
    return response.data;
  },

  getPosItemOffers: async (membertype:string):Promise<any> =>{
    
    const response= await axiosInstance.get<any>(`POS/GETItemwiseOfferJson?membertype=${membertype}`);
    return response.data;
  },

  getPosCustomerDetails :async(mobileno:string):Promise<any> =>{
    
    const response = await axiosInstance.get<any>(`POS/GetPOSCustomerDetails?mobileNo=${mobileno}`);
    return response.data;
  }


};
export default posService;